import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getMobilePage } from "../../../utils/ApiCalls/AddMobilePage";
import { getOneActivityCategory } from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import AddMobilePageData from "./EditMobilePageData";

const EditShowCustomList = () => {
  const params = useParams();
  const [activityCategory, setActivityCategory] = useState({});
  const [vesselData, setVesselData] = useState({});
  const [pageData, setPageData] = useState({});
  const [, dispatch] = useDataLayerValue();
  const [cat, setgetCat] = useState();

  useEffect(() => {
    getData(params?.cat);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getOneActivityCategory(value);
    let res = await getMobilePage({ id: params?.id });

    if (data.error || res?.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data?.error || res?.error, type: "error" },
      });

    setPageData(res?.data?.[0]);
    setActivityCategory(data.data);
    setVesselData(data?.vesselData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    activityCategory && (
      <AddMobilePageData
        page_type={"blog_item"}
        category={activityCategory}
        slug={params.id}
        pageData={pageData}
      />
    )
  );
};

export default EditShowCustomList;
